<template>
  <div class="detail-item">
    <div class="row">
      <div class="col-12 col-md">
        <p
          v-if="content.pv_infoblock_environmental_text"
          v-dynamic-content:pv_infoblock_environmental_text="[quote.panels.quantity]"
        ></p>
        <div class="row justify-content-center">
          <img
            class="col px-0 d-none d-md-block mb-5"
            src="@/assets/icons/milieubijdrage-line-art.svg"
          />
        </div>
        <div class="row">
          <div class="col-12 col-md-4 text-center mb-4">
            <img
              class="d-inline-block d-md-none mb-3"
              style="width: 135px"
              src="@/assets/icons/house-illustration.svg"
            />
            <h4
              class="font-size-bold px-9 px-md-0 mb-3"
              v-if="content.pv_infoblock_environmental_image_reducedco2"
              v-dynamic-content:pv_infoblock_environmental_image_reducedco2="[
                stylingwrapper($options.filters.formatWeight(quote.environmentalGains.co2)),
              ]"
            ></h4>
          </div>
          <div class="col-12 col-md-4 text-center mb-4">
            <img
              class="d-inline-block d-md-none mb-3"
              style="width: 135px"
              src="@/assets/icons/car-illustration.svg"
            />
            <h4
              class="font-size-bold px-9 px-md-0 mb-3"
              v-if="content.pv_infoblock_environmental_image_reducedkm"
              v-dynamic-content:pv_infoblock_environmental_image_reducedkm="[
                stylingwrapper($options.filters.formatMileage(quote.environmentalGains.mileage)),
              ]"
            ></h4>
          </div>
          <div class="col-12 col-md-4 text-center mb-4">
            <img
              class="d-inline-block d-md-none mb-3"
              style="width: 135px"
              src="@/assets/icons/trees-illustration.svg"
            />
            <h4
              class="font-size-bold px-9 px-md-0 mb-3"
              v-if="content.pv_infoblock_environmental_image_trees"
              v-dynamic-content:pv_infoblock_environmental_image_trees="[
                stylingwrapper($options.filters.formatAmount(quote.environmentalGains.trees)),
              ]"
            ></h4>
          </div>
        </div>
        <p
          v-if="isFlandersOrBrussels"
          class="mt-5"
          v-dynamic-content:pv_infoblock_environmental_recycling
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DetailEnvironment',
  props: {
    quote: {
      type: Object,
      required: true,
    },
  },
  methods: {
    stylingwrapper(dynamicKey) {
      return `<div class="environment-discription w-100 font-weight-bold text-primary ">${dynamicKey}</div>`
    },
  },
  computed: {
    ...mapGetters(['isFlandersOrBrussels']),
  },
}
</script>
